import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import UnitsAndEnums from "../components/UnitsAndEnums";
import LoaderComponent from "../components/LoaderComponent";
import { loadUnitsEnumsList } from "../api/unitsandenumsapi";
import { getUnitsAndEnumsList, getUnitsAndEnumsLoading } from "../selector/selectors";
import { Link } from "react-router-dom";


function ManageUnitsAndEnums({
  isLoading,
  unitsAndEnumsList,
  startLoadingUnitsEnums,
}) {

    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    useEffect(() => {
      startLoadingUnitsEnums();
    }, [startLoadingUnitsEnums]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingUnitsEnums(pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingUnitsEnums(0,event.target.value);
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Tab label="Units" value="1" />
                                <Link className="tabingLinks" to="/web/enums">Enums</Link>
                                <Link className="tabingLinks" to="/web/enum-groups">Enum Groups</Link>
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'flex-end'}}>
                               
                            </Grid>
                            <UnitsAndEnums filesList={unitsAndEnumsList} page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} />
                        </TabPanel>
                    </Grid>
                </TabContext>
                {/* <InterpretationFileModal
                    open={unitsAndEnumsDialogBoxStatus || false}
                    value={interpretationFormData}
                    setInterpretationFormData={setInterpretationFormData}
                    interpretationFile={interpretationFile}
                    setInterpretationFile={setInterpretationFile}
                    handleFormData={handleFormData}
                /> */}
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading: getUnitsAndEnumsLoading(state),  
  unitsAndEnumsList:getUnitsAndEnumsList(state),  
  //unitsAndEnumsDialogBoxStatus: getUnitsAndEnumsDialogStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    startLoadingUnitsEnums: (page,rowsPerPage) => dispatch(loadUnitsEnumsList(page,rowsPerPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUnitsAndEnums);

